export default function Header() {
  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-sky-600 to-sky-700 flex items-center justify-center">
              <span className="text-white font-bold text-lg">◎</span>
            </div>
            <h1 className="text-xl font-bold text-slate-900">Consensus</h1>
          </div>
          <nav className="hidden sm:flex gap-6 text-sm">
            <a href="#" className="text-slate-600 hover:text-slate-900 transition-colors">
              About
            </a>
            <a href="#" className="text-slate-600 hover:text-slate-900 transition-colors">
              Sources
            </a>
            <a href="#" className="text-slate-600 hover:text-slate-900 transition-colors">
              Contact
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
